/* ================== THE TICKET RAIL ==================
   Redemption arcade economics, stated in the open.

   One play costs 25c. The house must clear roughly 4x the
   prize cost on redeemed tickets, so the ticket has to be
   worth about a penny and a quarter and no more:

     revenue per play           = 25.0c
     prize cost allowed per play=  6.25c   (25 / 4)
     average tickets per play   =  5
     therefore ticket value     =  1.25c

   Every prize price below is its landed cost divided by
   1.25c. Change PRIZE_COST and the counter reprices itself.
   Tickets are earned by playing well, never bought.
   ==================================================== */
(function(){
  if (window.STATION_TICKETS) return;
  var KEY='station.tickets.v1';
  var TICKET_VALUE = 0.0125;      /* dollars a ticket is allowed to cost us */
  var MARGIN = 4;                 /* revenue : prize cost — 300% profit over cost */
  function read(){ try { return JSON.parse(localStorage.getItem(KEY)||'null') || {tickets:0, earned:0, spent:0, log:[], claims:[]}; }
                   catch(e){ return {tickets:0, earned:0, spent:0, log:[], claims:[]}; } }
  function save(s){ try{ localStorage.setItem(KEY, JSON.stringify(s)); }catch(e){} }
  function bus(){ try{ window.dispatchEvent(new CustomEvent('tickets')); }catch(e){} }

  /* tickets per run: a floor for showing up, then earned on performance.
     Tuned so an average run pays about 5 and a great one about 12. */
  function award(game, score, best){
    var s = read();
    var base = 2;
    var perf = Math.min(10, Math.floor((Number(score)||0) / Math.max(1, Number(best)||100) * 8));
    var n = Math.max(1, base + perf);
    s.tickets += n; s.earned += n;
    s.log.unshift({ g: game, n: n, sc: Number(score)||0, at: Date.now() });
    s.log = s.log.slice(0, 200);
    save(s); bus();
    return n;
  }
  function price(costDollars){ return Math.ceil((Number(costDollars)||0) / TICKET_VALUE); }
  function claim(prize, cost){
    var s = read(), need = price(cost);
    if (s.tickets < need) return { ok:false, need:need, have:s.tickets };
    s.tickets -= need; s.spent += need;
    var code = 'TK-' + Math.random().toString(36).slice(2,7).toUpperCase() + '-' + String(Date.now()).slice(-4);
    s.claims.unshift({ prize: prize, tickets: need, code: code, at: Date.now() });
    save(s); bus();
    return { ok:true, code:code, tickets:need };
  }
  window.STATION_TICKETS = {
    TICKET_VALUE: TICKET_VALUE, MARGIN: MARGIN,
    balance: function(){ return read().tickets; },
    state: read, award: award, price: price, claim: claim,
    reset: function(){ save({tickets:0, earned:0, spent:0, log:[], claims:[]}); bus(); }
  };
})();
